import { ButtonTitle } from "features/shared/styles/typography/ButtonTitle.styled";
import styled from "styled-components";

const LinkContent = styled.span`
  display: flex;
  align-items: center;
  justify-content: space-between;

  ${ButtonTitle} {
    color: ${({ theme }) => theme.colors.link};
  }
`;

export default LinkContent;
